import { Table } from 'antd';
import React from 'react'
import { Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

const ConsolSeaImport = () => {

    const navigate = useNavigate();

    const organisationOptions = [
        { value: 1, label: "Organisation 1" },
        { value: 2, label: "Organisation 2" },
        { value: 3, label: "Organisation 3" },
        { value: 4, label: "Organisation 4" },
        { value: 5, label: "Organisation 5" },
    ];

    const portOptions = [
        { value: 1, label: "Port 1" },
        { value: 2, label: "Port 2" },
        { value: 3, label: "Port 3" },
        { value: 4, label: "Port 4" },
        { value: 5, label: "Port 5" },
    ]

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "OL", dataIndex: "ol", key: "ol" },
        { title: "FL", dataIndex: "fl", key: "fl" },
        { title: "E Docket", dataIndex: "edocket", key: "edocket" },
        { title: "Consol No", dataIndex: "consolno", key: "consolno" },
        // { title: "Tracking No", dataIndex: "trackingno", key: "trackingno" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Consol Type", dataIndex: "consoltype", key: "consoltype" },
        { title: "Cargo Type", dataIndex: "cargotype", key: "cargotype" },
        { title: "Loading port", dataIndex: "loadingport", key: "loadingport" },
        { title: "Place of Discharge", dataIndex: "placeofdischarge", key: "placeofdischarge" },
        { title: "Shipping Line", dataIndex: "airline", key: "airline" },
        { title: "BL Number", dataIndex: "awbno", key: "awbno" },
        { title: "BL Issue by", dataIndex: "awbissuedby", key: "awbissuedby" },
        { title: "Active", dataIndex: "action", key: "action" },
    ];

    const dataSource = [
        {
            key: "1",
        }
    ];
    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Sea Import Consol<span className="count-title">3</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="icon-form mb-3 mb-sm-0">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search "
                                            name='search_by'
                                        />
                                    </div>
                                    <div className="form-sorts dropdown ms-2">
                                        <Tooltip placement="top" title="Filter">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                                // className='py-1'
                                                style={{
                                                    paddingTop: "7px",
                                                    paddingBottom: "6px"
                                                }}
                                            >
                                                <i className="ti ti-filter-share me-0" />
                                                {/* Filter */}
                                            </a>
                                        </Tooltip>

                                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                            <div className="filter-set-view">
                                                <table className="content-table">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Consol No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter Consol No."
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">HAWB No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter HAWB No."
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">AWB No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter AWB No."
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipment No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter Shipment no."
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipment from</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter Prefix"
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipment To</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter Prefix"
                                                                    name="email"
                                                                />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Active</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="YES">YES</option>
                                                                    <option value="NO">NO</option>
                                                                </select>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Console Type</label>
                                                            </td>
                                                            <td className="input_box_filter">

                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="ALL">All</option>
                                                                    <option value="1">Direct</option>
                                                                    <option value="2">Buyer Consol</option>
                                                                    <option value="2">Agent Consol</option>
                                                                    <option value="1">Back to Back</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Status</label>
                                                            </td>
                                                            <td className="input_box_filter">

                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option selected> All </option>
                                                                    <option> Booking Received from Shipper </option>
                                                                    <option> Job Order Created </option>
                                                                    <option> Carrier Booking </option>
                                                                    <option> Goods Received </option>
                                                                    <option> S/B Filed </option>
                                                                    <option> Shipment Created </option>
                                                                    <option> Customs Formalities at Origin </option>
                                                                    <option> Goods Carted </option>
                                                                    <option> Goods Examined </option>
                                                                    <option> Goods Handed Over </option>
                                                                    <option> Loaded on Carrier </option>
                                                                    <option> Goods Carted </option>
                                                                    <option> Reached at Destination </option>
                                                                    <option> Goods Delivered </option>
                                                                    <option> Flight One Departed </option>
                                                                    <option> Billing </option>
                                                                    <option> Cargo Arrival Notice Sent </option>
                                                                    <option> DO Issued </option>
                                                                    <option> Customs Formalities at Destination </option>
                                                                    <option> Pending </option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipper</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <Select
                                                                    id="Shipper"
                                                                    className='mt-2 custom-selector w-100'
                                                                    options={organisationOptions}
                                                                    name="role_id"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Consignee</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <Select
                                                                    id="Shipper"
                                                                    className='mt-2 custom-selector w-100'
                                                                    options={organisationOptions}
                                                                    name="role_id"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Load Port</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <Select
                                                                    id="Shipper"
                                                                    className='mt-2 custom-selector w-100'
                                                                    options={portOptions}
                                                                    name="role_id"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Discharge Port</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <Select
                                                                    id="Shipper"
                                                                    className='mt-2 custom-selector w-100'
                                                                    options={portOptions}
                                                                    name="role_id"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="filter-reset-btns">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <a className="btn btn-light">
                                                                Reset
                                                            </a>
                                                        </div>
                                                        <div className="col-6">
                                                            <button type='submit' className="btn btn-primary w-100">
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                            {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>
                                            {/* <ReactTooltip id="export" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        Clear
                                    </a>
                                    <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        // onClick={handleAddShow}
                                        onClick={() => { navigate("/flexichain/consol-sea-import/add") }}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add Consol
                                    </div>

                                </div>
                            </div>
                            {/* /Filter */}
                            {/* Contact List */}

                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsolSeaImport